import React, { useEffect, useState } from "react";
import BlogBanner from "./BlogBanner";
import "./blog.scss";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Loader from "../../hooks/loader";

const Blog = () => {
  const [blogsData, setBlogsData] = useState([]);
  const [blogsDataSingle, setBlogsDataSingle] = useState([]);
  const [mainLoader, setMainLoader] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogs();
  }, []);

  const getBlogs = () => {
    var config = {
      method: "get",
      url: `https://blog.gems.vip/wp-json/wp/v2/posts?per_page=100`,
    };

    axios(config)
      .then(function (res) {
        console.log("blog data: ", res);

        // Set the first blog in blogsDataSingle
        if (res?.data?.length > 0) {
          setBlogsDataSingle([res.data[0]]); // Wrapping in an array for consistency
          setBlogsData(res.data.slice(1)); // Remaining blogs
        }
      })
      .catch(function (error) {
        console.error("Error fetching blogs:", error);
      });
  };

  function removePTags(htmlString) {
    return htmlString.replace(/<\/?p>/gi, "");
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setMainLoader(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {mainLoader && <Loader /> }
      <div className="wrapper-apply wrapper-career wrapper-blog">
 
        <BlogBanner blogsDataSingle={blogsDataSingle} />
        <section className="blog-section">
          <div className="custom-container">
            <div className="parent">
              {blogsData?.length > 0 ? (
                blogsData?.map((item, index) => {
                  const cleanText = removePTags(item?.title?.rendered);

                  return (
                    <>
                      <Link
                        to={{
                          pathname: `/blog/${item?.slug}`,
                          state: {
                            id: item?.id,
                          },
                        }}
                      >
                        <div className="single-card">
                          <div className="main-img">
                            <img
                              //   src="\assets\dummy\1.png"
                              src={item?.uagb_featured_image_src?.large[0]}
                              alt="img"
                              className="img-fluid"
                            />
                          </div>
                          <div className="bottom-text">
                            <p>
                              [{moment(item?.date).format("MMMM DD, YYYY")}]
                            </p>
                            <h6>{cleanText}</h6>
                          </div>
                        </div>
                      </Link>
                    </>
                  );
                })
              ) : (
                <></>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Blog;
